export const getLinkedSocialEntry = (profiles, platform) => {
  const entry = profiles?.[platform];
  if (!entry?.profileUrl) return null;
  return entry;
};

export const hasLinkedSocialProfiles = (profiles) =>
  Boolean(
    getLinkedSocialEntry(profiles, "facebook") ||
      getLinkedSocialEntry(profiles, "instagram")
  );

export const SELLER_SOCIAL_REQUIRED_MESSAGE =
  "Link at least one Facebook or Instagram profile so buyers can verify you are a real person.";

export const formatSocialHandle = (platform, entry) => {
  if (!entry) return "";
  if (entry.username) {
    return platform === "instagram" ? `@${entry.username}` : entry.username;
  }
  return platform === "facebook" ? "Facebook" : "Instagram";
};
